import React, { useEffect } from "react";
import {
  Container, Typography, Grid, Paper, Button, Box
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const VisitorDashboard = () => {

  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (!user || user.role !== 'visitor') {
      navigate('/login', { replace: true });
    }
  }, [user, navigate]);

  if (!user || user.role !== 'visitor') return null;

  const visitorActions = [
    {
      title: "Register Visit",
      description: "Schedule and register a new visit",
      path: "/visitor-registration"
    },
    {
      title: "Checkout Scanner",
      description: "Select a visit and complete checkout",
      path: "/select-visit"
    }
  ];

  return (
    <Box sx={{ minHeight: "100vh", background: "#fefce8", py: 4 }}>

      <Container maxWidth="lg">

        {/* HEADER */}
        <Box sx={{ mb: 4 }}>
          <Typography sx={{
            fontSize: "2rem",
            fontWeight: 900,
            fontFamily: "'Unbounded', sans-serif",
            color: "#1c1400"
          }}>
            Visitor Dashboard
          </Typography>

          <Typography sx={{ color: "#8a7a40", mt: 0.5 }}>
            Welcome, {user?.userName || user?.email}
          </Typography>

          <Typography sx={{
            color: "#6b7280",
            mt: 1,
            fontSize: "0.95rem"
          }}>
            Easily register visits and manage your checkouts.
          </Typography>
        </Box>

        {/* ACTION CARDS */}
        <Grid container spacing={3}>
          {visitorActions.map((action, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Paper sx={{
                p: 3,
                borderRadius: "14px",
                border: "1px solid #f0d060",
                background: "#ffffff",
                transition: "0.3s",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 10px 20px rgba(0,0,0,0.08)"
                }
              }}>

                <Box>
                  <Typography sx={{
                    fontWeight: 700,
                    color: "#1c1400"
                  }}>
                    {action.title}
                  </Typography>

                  <Typography sx={{
                    color: "#6b7280",
                    fontSize: "0.9rem",
                    mt: 1
                  }}>
                    {action.description}
                  </Typography>
                </Box>

                <Button
                  fullWidth
                  sx={{
                    mt: 2,
                    background: "#1c1400",
                    color: "#fde047",
                    borderRadius: "8px",
                    fontWeight: 600,
                    "&:hover": {
                      background: "#f59e0b",
                      color: "#1c1400"
                    }
                  }}
                  onClick={() => navigate(action.path)}
                >
                  Access
                </Button>

              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* INFO BOX */}
        <Box sx={{ mt: 4 }}>
          <Paper sx={{
            p: 3,
            borderRadius: "12px",
            background: "#fffbea",
            border: "1px solid #f0d060"
          }}>
            <Typography sx={{ color: "#6b7280" }}>
              As a visitor, you can register visits and manage your checkouts quickly and securely.
            </Typography>
          </Paper>
        </Box>

      </Container>
    </Box>
  );
};

export default VisitorDashboard;